import { Injectable } from '@angular/core';
import type { CalculateFeeMegaResponse } from './interfaces/calculate-fee-mega-response';
import type { CalculateFeeMegaRequest, CdxRequest } from './interfaces/calculate-fee-mega-request';
import type { CommitMegaResponse } from './interfaces/commit-mega-response';
import type { RetrieveMegaResponse } from './interfaces/retrieve-mega-response';

@Injectable()
export class PassDataService {
  private calculateFeeMegaResponse: CalculateFeeMegaResponse;
  private calculateFeeMegaRequest: CalculateFeeMegaRequest;
  private commitMegaResponse: CommitMegaResponse;
  private repopulateBundle: CdxRequest;
  private megaType = '';
  private settledMegaRecreateMegaType = '';
  private retrieveMegaResponse: RetrieveMegaResponse;
  private editMegaFlow = false;
  private poolNumberEditMegaFlow: number;
  private cusipEditMegaFlow: string;
  private revisionNumber: number;
  private jobReferenceUuid: string;
  private isUploadCancelledFromValidatePoolsPage = false;
  private cancelErrorMessageFromValidatePool = '';
  public validatedMegaList: any;
  private detectedMegaList: any;
  private totalCountFromValidatePools: number;
  private commitUploadCollateralResponse: any;
  private multiMegaRequest: any;
  private multiMegaResponse: any;
  private multiMegaExcelDetail: any;
  private goBackAndEditFlag: any;
  private dropdownSelectedMegaType: any;
  private multiMegaCommitRequest: any;
  private multiMegaCommitResponse: any;
  private multiMegaValidationResponse: any;
  private isRememberSelectionCbChecked = false;
  private dropDownSelectedCusip: any;
  private dropDownSelectedOface: any;
  private excelSheetContent: any;
  private collateralCUSIPList: any;
  private analyzerValidatedCollateralResponse: any;
  private analyzerUploadedFileName: string;
  private analyzerUploadedFileSheetName: string;
  private dropDownSelectedSheetName: any;
  private rememberSheetSelection: string;
  private collateralAnalyzerDownloadExcelRequest: any;
  private isHeaderChecked = true;
  private megaFlowGoBackAndEditLink = false;
  private feeTickValue = 0;

  private disclosureWaDetailsRes: any;
  private disclosureSellerDetailsRes: any;
  private loanPurposeRes: any;
  private propertyTypeRes: any;
  private channelRes: any;
  private occupancyStatusRes: any;
  private numberOfUnitsRes: any;
  private originationYearRes: any;
  private stateRes: any;
  private servicersRes: any;
  private borrowersRes: any;
  private mortgageInsCancelIndRes: any;
  private mortgageInsCoverageRes: any;
  private servicersLessThanOnePercentRes: any;

  private mortgageLoanAmountQuartileRes: any;
  private interestRateQuartileRes: any;
  private netInterestRateCurrentQuartileRes: any;
  private loanTermQuartileRes: any;
  private loanAgeQuartileRes: any;
  private loanToValueQuartileRes: any;
  private combinedLoanToValueQuartileRes: any;
  private borrowerCreditScoreQuartileRes: any;
  private remainingMonthsToMaturityQuartileRes: any;

  private quartileCompleteRes: any;

  private showAnalyzerDetailsErrorIcon: any;
  private showAnalyzerStatisticsErrorIcon: any;
  private showAnalyzerStatisticsQuartileErrorIcon: any;

  private showAnalyzerStatisticsTmpMegaError: boolean;
  private showAnalyzerDetailsTmpMegaError: boolean;

  private disclosurePDFButton: boolean;

  private collateralUploadFileName: string;

  private tempMega = '';

  public setSettledMegaRecreateMegaType(value: string) {
    this.settledMegaRecreateMegaType = value;
  }

  public getSettledMegaRecreateMegaType(): string {
    return this.settledMegaRecreateMegaType;
  }

  public setCalculateFeeMegaResponse(value: CalculateFeeMegaResponse) {
    this.calculateFeeMegaResponse = value;
  }

  public getCalculateFeeMegaResponse(): CalculateFeeMegaResponse {
    return this.calculateFeeMegaResponse;
  }

  public setCalculateFeeMegaRequest(value: CalculateFeeMegaRequest) {
    this.calculateFeeMegaRequest = value;
  }

  public getCalculateFeeMegaRequest(): CalculateFeeMegaRequest {
    return this.calculateFeeMegaRequest;
  }

  public getFeeTickValue(): number {
    return this.feeTickValue;
  }

  public setFeeTickValue(value: number) {
    this.feeTickValue = value;
  }

  public setMegaRepopulateBundle(value: CdxRequest) {
    this.repopulateBundle = value;
  }

  public getMegaRepopulateBundle(): CdxRequest {
    return this.repopulateBundle;
  }

  public getMegaType(): string {
    return this.megaType;
  }

  public setMegaType(value: string) {
    this.megaType = value;
  }

  public setCommitMegaResponse(value: CommitMegaResponse) {
    this.commitMegaResponse = value;
  }

  public getCommitMegaResponse(): CommitMegaResponse {
    return this.commitMegaResponse;
  }

  public setRetrieveMegaResponse(value: RetrieveMegaResponse) {
    this.retrieveMegaResponse = value;
  }

  public getRetrieveMegaResponse(): RetrieveMegaResponse {
    return this.retrieveMegaResponse;
  }

  public getEditMegaFlow(): boolean {
    return this.editMegaFlow;
  }

  public setEditMegaFlow(value: boolean) {
    this.editMegaFlow = value;
  }

  public getpoolNumberEditMegaFlow(): number {
    return this.poolNumberEditMegaFlow;
  }

  public setpoolNumberEditMegaFlow(value: number) {
    this.poolNumberEditMegaFlow = value;
  }

  public getCUSIPEditMegaFlow(): string {
    return this.cusipEditMegaFlow;
  }

  public setCUSIPEditMegaFlow(value: string) {
    this.cusipEditMegaFlow = value;
  }

  public getRevisionNumber(): number {
    return this.revisionNumber;
  }

  public setRevisionNumber(value: number) {
    this.revisionNumber = value;
  }

  public getJobReferenceUUID(): string {
    return this.jobReferenceUuid;
  }

  public setJobReferenceUUID(value: string) {
    this.jobReferenceUuid = value;
  }

  public setIsUploadCancelledFromValidatePoolsPage(value: boolean) {
    this.isUploadCancelledFromValidatePoolsPage = value;
  }

  public getIsUploadCancelledFromValidatePoolsPage(): boolean {
    return this.isUploadCancelledFromValidatePoolsPage;
  }

  public setCancelErrorMessageFromValidatePool(value: string) {
    this.cancelErrorMessageFromValidatePool = value;
  }

  public getCancelErrorMessageFromValidatePool(): string {
    return this.cancelErrorMessageFromValidatePool;
  }

  public getDetectedMegaList(): any {
    return this.detectedMegaList;
  }

  public setDetectedMegaList(value: any) {
    this.detectedMegaList = value;
  }

  public getValidatedMegaList(): any {
    return this.validatedMegaList;
  }

  public setValidatedMegaList(value: any) {
    this.validatedMegaList = value;
  }

  public getTotalCountFromValidatePools(): number {
    return this.totalCountFromValidatePools;
  }

  public setTotalCountFromValidatePools(value: number) {
    this.totalCountFromValidatePools = value;
  }

  public getCommitUploadCollateralResponse(): any {
    return this.commitUploadCollateralResponse;
  }

  public setCommitUploadCollateralResponse(value: any) {
    this.commitUploadCollateralResponse = value;
  }

  public getMultiMegaRequest(): any {
    return this.multiMegaRequest;
  }

  public setMultiMegaRequest(value: any) {
    this.multiMegaRequest = value;
  }

  public getMultiMegaResponse(): any {
    return this.multiMegaResponse;
  }

  public setMultiMegaResponse(value: any) {
    this.multiMegaResponse = value;
  }

  public getMultiMegaExcelData(): any {
    return this.multiMegaExcelDetail;
  }

  public setMultiMegaExcelData(value: any) {
    this.multiMegaExcelDetail = value;
  }

  public getGoBackEditFlag(): any {
    return this.goBackAndEditFlag;
  }

  public setGoBackEditFlag(value: any) {
    this.goBackAndEditFlag = value;
  }

  public getDropdownSelectedMegaType(): any {
    return this.dropdownSelectedMegaType;
  }

  public setDropdownSelectedMegaType(value: any) {
    this.dropdownSelectedMegaType = value;
  }

  public getMultiMegaCommitRequest(): any {
    return this.multiMegaCommitRequest;
  }

  public setMultiMegaCommitRequest(value: any) {
    this.multiMegaCommitRequest = value;
  }

  public setMultiMegaCommitResponse(value: any) {
    this.multiMegaCommitResponse = value;
  }

  public getMultiMegaCommitResponse(): any {
    return this.multiMegaCommitResponse;
  }

  public setMultiMegaValidationResponse(value: any) {
    this.multiMegaValidationResponse = value;
  }

  public getMultiMegaValidationResponse(): any {
    return this.multiMegaValidationResponse;
  }

  public setIsRememberSelectionCbChecked(value: boolean) {
    this.isRememberSelectionCbChecked = value;
  }

  public getIsRememberSelectionCbChecked(): boolean {
    return this.isRememberSelectionCbChecked;
  }

  public getDropDownSelectedCusip(): any {
    return this.dropDownSelectedCusip;
  }

  public setDropDownSelectedCusip(value: any) {
    this.dropDownSelectedCusip = value;
  }

  public getDropDownSelectedOface(): any {
    return this.dropDownSelectedOface;
  }

  public setDropDownSelectedOface(value: any) {
    this.dropDownSelectedOface = value;
  }

  public getExcelSheetContent(): any {
    return this.excelSheetContent;
  }

  public setExcelSheetContent(value: any) {
    this.excelSheetContent = value;
  }

  public getCollateralCUSIPList(): any {
    return this.collateralCUSIPList;
  }

  public setCollateralCUSIPList(value: any) {
    this.collateralCUSIPList = value;
  }

  public getAnalyzerValidatedCollateralResponse(): any {
    return this.analyzerValidatedCollateralResponse;
  }

  public setAnalyzerValidatedCollateralResponse(value: any) {
    this.analyzerValidatedCollateralResponse = value;
  }

  public getAnalyzerUploadedFileName(): string {
    return this.analyzerUploadedFileName;
  }

  public setAnalyzerUploadedFileName(value: string) {
    this.analyzerUploadedFileName = value;
  }

  public getAnalyzerUploadedFileSheetName(): string {
    return this.analyzerUploadedFileSheetName;
  }

  public setAnalyzerUploadedFileSheetName(value: string) {
    this.analyzerUploadedFileSheetName = value;
  }

  public getDropDownSelectedSheetName(): any {
    return this.dropDownSelectedSheetName;
  }

  public setDropDownSelectedSheetName(value: any) {
    this.dropDownSelectedSheetName = value;
  }

  public getRememberSheetSelection(): string {
    return this.rememberSheetSelection;
  }

  public setRememberSheetSelection(value: string) {
    this.rememberSheetSelection = value;
  }

  public getCollateralAnalyzerDownloadExcelRequest(): any {
    return this.collateralAnalyzerDownloadExcelRequest;
  }

  public setCollateralAnalyzerDownloadExcelRequest(value: any) {
    this.collateralAnalyzerDownloadExcelRequest = value;
  }

  public getIsHeaderChecked(): boolean {
    return this.isHeaderChecked;
  }

  public setIsHeaderChecked(value: boolean) {
    this.isHeaderChecked = value;
  }

  /*
   * disclosure details
   */

  public setDisclosureWaDetailsRes(value: any) {
    this.disclosureWaDetailsRes = value;
  }

  public getDisclosureWaDetailsRes(): any {
    return this.disclosureWaDetailsRes;
  }

  public setDisclosureSellerDetailsRes(value: any) {
    this.disclosureSellerDetailsRes = value;
  }

  public getDisclosureSellerDetailsRes(): any {
    return this.disclosureSellerDetailsRes;
  }

  public setLoanPurposeRes(value: any) {
    this.loanPurposeRes = value;
  }

  public getLoanPurposeRes(): any {
    return this.loanPurposeRes;
  }

  public setPropertyTypeRes(value: any) {
    this.propertyTypeRes = value;
  }

  public getPropertyTypeRes(): any {
    return this.propertyTypeRes;
  }

  public setChannelRes(value: any) {
    this.channelRes = value;
  }

  public getChannelRes(): any {
    return this.channelRes;
  }

  public setoccupancyStatusRes(value: any) {
    this.occupancyStatusRes = value;
  }

  public getoccupancyStatusRes(): any {
    return this.occupancyStatusRes;
  }

  public setNumberOfUnitsRes(value: any) {
    this.numberOfUnitsRes = value;
  }

  public getNumberOfUnitsRes(): any {
    return this.numberOfUnitsRes;
  }

  public setOriginationYearRes(value: any) {
    this.originationYearRes = value;
  }

  public getOriginationYearRes(): any {
    return this.originationYearRes;
  }

  public setStateRes(value: any) {
    this.stateRes = value;
  }

  public getStateRes(): any {
    return this.stateRes;
  }

  public setServicersRes(value: any) {
    this.servicersRes = value;
  }

  public getServicersRes(): any {
    return this.servicersRes;
  }

  public setBorrowersRes(value: any) {
    this.borrowersRes = value;
  }

  public getBorrowersRes(): any {
    return this.borrowersRes;
  }

  public setMortgageInsCancelIndRes(value: any) {
    this.mortgageInsCancelIndRes = value;
  }

  public getMortgageInsCancelIndRes(): any {
    return this.mortgageInsCancelIndRes;
  }

  public setMortgageInsCoverageRes(value: any) {
    this.mortgageInsCoverageRes = value;
  }

  public getMortgageInsCoverageRes(): any {
    return this.mortgageInsCoverageRes;
  }

  public setMortgageLoanAmountQuartileRes(value: any) {
    this.mortgageLoanAmountQuartileRes = value;
  }

  public getMortgageLoanAmountQuartileRes(): any {
    return this.mortgageLoanAmountQuartileRes;
  }

  public setInterestRateQuartileRes(value: any) {
    this.interestRateQuartileRes = value;
  }

  public getInterestRateQuartileRes(): any {
    return this.interestRateQuartileRes;
  }

  public setNetInterestRateCurrentQuartileRes(value: any) {
    this.netInterestRateCurrentQuartileRes = value;
  }

  public getNetInterestRateCurrentQuartileRes(): any {
    return this.netInterestRateCurrentQuartileRes;
  }

  public setLoanTermQuartileRes(value: any) {
    this.loanTermQuartileRes = value;
  }

  public getLoanTermQuartileRes(): any {
    return this.loanTermQuartileRes;
  }

  public setloanAgeQuartileRes(value: any) {
    this.loanAgeQuartileRes = value;
  }

  public getloanAgeQuartileRes(): any {
    return this.loanAgeQuartileRes;
  }

  public setLoanToValueQuartileRes(value: any) {
    this.loanToValueQuartileRes = value;
  }

  public getLoanToValueQuartileRes(): any {
    return this.loanToValueQuartileRes;
  }

  public setCombinedLoanToValueQuartileRes(value: any) {
    this.combinedLoanToValueQuartileRes = value;
  }

  public getCombinedLoanToValueQuartileRes(): any {
    return this.combinedLoanToValueQuartileRes;
  }

  public setBorrowerCreditScoreQuartileRes(value: any) {
    this.borrowerCreditScoreQuartileRes = value;
  }

  public getBorrowerCreditScoreQuartileRes(): any {
    return this.borrowerCreditScoreQuartileRes;
  }

  public setRemainingMonthsToMaturityQuartileRes(value: any) {
    this.remainingMonthsToMaturityQuartileRes = value;
  }

  public getRemainingMonthsToMaturityQuartileRes(): any {
    return this.remainingMonthsToMaturityQuartileRes;
  }

  public setQuartileCompleteRes(value: any) {
    this.quartileCompleteRes = value;
  }

  public getQuartileCompleteRes(): any {
    return this.quartileCompleteRes;
  }

  public setServicersLessThanOnePercentRes(value: any) {
    this.servicersLessThanOnePercentRes = value;
  }

  public getServicersLessThanOnePercentRes(): any {
    return this.servicersLessThanOnePercentRes;
  }

  public setAnalyzerDetailsErrorIconVal(value: any) {
    this.showAnalyzerDetailsErrorIcon = value;
  }

  public getAnalyzerDetailsErrorIconVal(): any {
    return this.showAnalyzerDetailsErrorIcon;
  }

  public setAnalyzerStatisticsErrorIconVal(value: any) {
    this.showAnalyzerStatisticsErrorIcon = value;
  }

  public getAnalyzerStatisticsErrorIconVal(): any {
    return this.showAnalyzerStatisticsErrorIcon;
  }

  public setAnalyzerStatisticsQuartileErrorIconVal(value: any) {
    this.showAnalyzerStatisticsQuartileErrorIcon = value;
  }

  public getAnalyzerStatisticsQuartileErrorIconVal(): any {
    return this.showAnalyzerStatisticsQuartileErrorIcon;
  }

  public setAnalyzerStatisticsTmpMegaError(value: boolean) {
    this.showAnalyzerStatisticsTmpMegaError = value;
  }

  public getAnalyzerStatisticsTmpMegaError(): boolean {
    return this.showAnalyzerStatisticsTmpMegaError;
  }

  public setAnalyzerDetailsTmpMegaError(value: boolean) {
    this.showAnalyzerDetailsTmpMegaError = value;
  }

  public getAnalyzerDetailsTmpMegaError(): boolean {
    return this.showAnalyzerDetailsTmpMegaError;
  }

  public setDisclosurePDFButton(value: boolean) {
    this.disclosurePDFButton = value;
  }

  public getDisclosurePDFButton(): boolean {
    return this.disclosurePDFButton;
  }

  public setCollateralUploadFileName(value: string) {
    this.collateralUploadFileName = value;
  }

  public getCollateralUploadFileName(): string {
    return this.collateralUploadFileName;
  }

  public setMegaFlowGoBackAndEditLink(value: boolean) {
    this.megaFlowGoBackAndEditLink = value;
  }

  public getMegaFlowGoBackAndEditLink(): boolean {
    return this.megaFlowGoBackAndEditLink;
  }

  public setTempMega(value: string) {
    this.tempMega = value;
  }

  public getTempMega(): string {
    return this.tempMega;
  }
}
